<div class="addNewPolicyContainer">
<div class="Clears"></div>
     <div class="TabsSection">
        
                <div class="row">
                        <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                   <div class="card" style="width:100%;">
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation"><a href="#home" aria-controls="home" role="tab" data-toggle="tab">Travel Insurance</a></li>
                        <li role="presentation"><a href="#profile" aria-controls="profile" role="tab" data-toggle="tab">Medmal Insurance</a></li>
                        <li role="presentation"  class="active"><a href="#messages" aria-controls="messages" role="tab" data-toggle="tab">Motor Insurance</a></li>
                        <!-- <li role="presentation"><a href="#settings" aria-controls="settings" role="tab" data-toggle="tab">Settings</a></li> -->
                    </ul>

                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane " id="home">
                           In Progress
                        </div>
                        <div role="tabpanel" class="tab-pane" id="profile">
                           In Progress
                        </div>
                        <div role="tabpanel" class="tab-pane active" id="messages">
                                <div class="InsuredInformation Infomation">
                                  
                                        <div class="FormSection">
                                              
                                                    <div class="Clears"></div>
                          
                                                   
                                            <div class="Field">
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                        <label>Vehicle Definition Type</label>
                                                    </div>
                                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                          <select class="form-control" [(ngModel)]="AddNewPolicyObj.VehicleDefionitionType">
                                                                  <option value="2">Sequence No</option>
                                                                    <option value="3">Customer Id</option>
                                                                   
                                                              </select>
                                                        </div>
                                                </div>
                                            </div>
                          
                                            <div class="Field">
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                            <label>ID Number</label>
                                                        </div>
                                                        <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                              <input class="form-control" placeholder="Iqama No" type="text" [(ngModel)]="AddNewPolicyObj.IqamaNo" disabled>
                                                                
                                                                    
                                                    </div>
                                                </div>
                                            </div>
                          
                                          
                                         
                                                    
                                            <div class="Field"   *ngIf="AddNewPolicyObj.VehicleDefionitionType=='2'">
                                                  <div class="row">
                                                      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                          <label>Sequence No</label>
                                                      </div>
                                                      <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                            <input class="form-control" placeholder="Sequence No" type="text"  [(ngModel)]="AddNewPolicyObj.SequenceNo">
                                                              
                                                                  
                                                  </div>
                                              </div>
                                          </div>
                          
                                         
                          
                                          <div class="Field" *ngIf="AddNewPolicyObj.VehicleDefionitionType=='3'">
                                                  <div class="row">
                                                      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                          <label>Customer Id</label>
                                                      </div>
                                                      <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                            <input class="form-control" placeholder="Customer Id" type="text" [(ngModel)]="AddNewPolicyObj.CustomerId" >
                                                              
                                                                  
                                                  </div>
                                              </div>
                                          </div>
                                                
                                          <div class="Field" class="Field" *ngIf="AddNewPolicyObj.VehicleDefionitionType=='3'">
                                                  <div class="row">
                                                      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                          <label>Custom ID Issuence Date</label>
                                                      </div>
                                                      <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                            <input class="form-control" placeholder="Custom ID Issuence Date" type="text" [(ngModel)]="AddNewPolicyObj.CustomerIssueDate" >
                                                              
                                                                  
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="Field">
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                       
                                                    </div>
                                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                            <label class="transfer"><input type="checkbox" (change)="checked($event)"/>Transfer of OwnerShip</label>
                                                            
                                                                
                                                </div>
                                            </div>
                                        </div>
                          
                                          <div class="Field" *ngIf="AddNewPolicyObj.Transfer">
                                                  <div class="row">
                                                      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                          <label>Owner ID Number</label>
                                                      </div>
                                                      <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                            <input class="form-control" placeholder="Owner Iqama No" type="text"  [(ngModel)]="AddNewPolicyObj.OwnerIqamaNo">
                                                              
                                                                  
                                                  </div>
                                              </div>
                                          </div>
                                                       
                                        </div>
                          
                           
                          
                          
                                     
                                      
                          <!-- Button Actions -->
                          
                          <div class="Actionsection" >
                            <div class="Actions">
                                    <div class="btn-group">
                                           
                                                    <button type="button" class="btn btn-primary btns" (click)="Proceed()">Proceed</button>
                                                    
                                                </div>
                            </div>
                          </div>
                          <div class="Clears"></div>
                                        
                                        </div>
                        
                        </div>
                        <!-- <div role="tabpanel" class="tab-pane" id="settings">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passage..</div> -->
                    </div>
</div>
                </div>

                <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
</div>
         
     </div>

            <div class="AddNewForm" *ngIf=false>
                    <div class="col-lg-2 col-md-2 hidden-sm hidden-xs">

                        </div>
                    
                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                            <div class="Clears"></div>
                           
                    
                    
                    
                                 
                    </div>
                                  <div class="col-lg-2 col-md-2 hidden-sm hidden-xs">
                            
                                    </div>
            </div>
    

                <div class="Clears"></div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/AddNewPolicy/AddNewPolicy.html